module.exports = __webpack_public_path__ + "efd3665648c2bea6266300a2ce0e088f.svg";